<script>
    import { onMount } from "svelte";

    import { user } from "../../stores";

    import {
        PageHead,
        PageLoading,
    } from "../../Components/Common/index.svelte";

    import { apiMethods } from "../../Services/index.svelte";

    import {
        goToDownloadPage,
        showError,
    } from "../../Utils/utilFunctions.svelte";

    import ViewInvoicesHeadDetails from "../Invoices/components/ViewInvoicesHeadDetails.svelte";
    import ViewInvoicesDoctorDetails from "../Invoices/components/ViewInvoicesDoctorDetails.svelte";
    import ViewInvoicesInvoiceDetails from "../Invoices/components/ViewInvoicesInvoiceDetails.svelte";
    import GroupInvoiceItems from "../GroupInvoices/components/GroupInvoiceItems.svelte";

    export let params = {};

    let isLoading = false,
        isDownloadingPDF = false,
        invoiceDetails = {},
        doctorDetails = {};

    $: isUserEnableSeeDoctorDetails = $user.role >= 20;

    onMount(() => {
        if (params.id) getInvoiceDetails(params.id);
    });

    const getInvoiceDetails = (id) => {
        isLoading = true;

        apiMethods.getMethod.getAccountInvoiceById(id).then((res) => {
            if (res.id) {
                invoiceDetails = { ...res };

                _updateBillingItemsData();

                _updateDoctorDetails(res);

                isLoading = false;

                // loadAccountDetails(res.doctorId);
            } else {
                isLoading = false;
                showError(
                    "Unable to load this invoice, please refresh the page and try again and contact support if the issue persists.",
                    true,
                );
            }
        });
    };

    // const loadAccountDetails = (id) => {
    //     apiMethods.getMethod.getAccountById(id).then((res) => {
    //         if (res.id) _updateDoctorDetails(res);
    //         else showError("Unable to load doctor details", true);
    //     });
    // };

    const getFile = () => {
        goToDownloadPage(5, invoiceDetails.id);
    };

    const _updateBillingItemsData = () => {
        if (invoiceDetails.billingItems.length) {
            const lastItem = {
                isLast: true,
                totalAmount: invoiceDetails.billingItems.reduce(
                    (sum, { totalAmount }) => sum + totalAmount,
                    0,
                ),
            };

            invoiceDetails.billingItems.push(lastItem);
        }
    };

    const _updateDoctorDetails = (res) => {
        doctorDetails = {
            ...res.billingDetails,
            id: res.doctorId,
        };
    };
</script>

{#if isLoading}
    <PageLoading />
{:else}
    <PageHead
        title="View invoice details"
        buttonText={isDownloadingPDF
            ? "Downloading PDF"
            : "Download invoice PDF"}
        buttonStyle={isDownloadingPDF ? "loading" : ""}
        buttonDisabled={isDownloadingPDF}
        buttonFunc={getFile}
        isRevertBtnOrder={true}
    />

    <div class="flex-1 relative mt-4">
        <div class="flex flex-col overflow-y-auto absolute inset-0 gap-4 px-2">
            <ViewInvoicesHeadDetails {invoiceDetails} />

            {#if isUserEnableSeeDoctorDetails}
                <ViewInvoicesDoctorDetails {doctorDetails} />
            {/if}

            <ViewInvoicesInvoiceDetails
                {invoiceDetails}
                downloadInvoiceType={5}
                isFromAccountPage
            />

            <GroupInvoiceItems billingItems={invoiceDetails.billingItems} />
        </div>
    </div>
{/if}
